import { Component, ViewChild, Inject, DOCUMENT } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from '@utils/theme';
import { TranslocoPreloader } from '@utils/preload.service';
import { IconService } from '@utils/icon.service';
import { DevModeComponent } from '@ui/dev-mode/dev-mode.component'
import { JsonLDService } from '@seo/json-ld.service';
import { firstValueFrom } from 'rxjs';
import env from '@env';

@Component({
  selector: 'market-root',
  imports: [RouterOutlet, DevModeComponent],
  template: `
    <router-outlet />
    @if (devMode) {
      <dev-mode (close)="devMode = false" />
    }
    `,
})
export class AppComponent {
  devMode = env.configuration === 'dev' || env.configuration === 'beta';

  @ViewChild(RouterOutlet) outlet?: RouterOutlet;

  constructor(
    @Inject(DOCUMENT) doc: Document,
    theme: ThemeService,
    transloco: TranslocoService,
    translocoPreloader: TranslocoPreloader,
    icons: IconService,
    jsonLD: JsonLDService,
  ) {
    theme.init();
    translocoPreloader.preload(['auth', 'market', 'bucket', 'invoice']);
    doc.documentElement.lang = transloco.getActiveLang();

    icons.register(['google', 'google_cluster', 'kampoy', 'local_payments', 'local_payments_off']);
    icons.registerMaterial();

    firstValueFrom(transloco.load(`home/${transloco.getActiveLang()}`)).then(t => {
      jsonLD.app({
        name: 'Kampoy',
        description: t.seo.description,
        applicationCategory: 'ShoppingApplication',
        countriesSupported: 'fr',
        offers: { '@type': 'Offer', price: 0, priceCurrency: 'EUR' },
        // screenshot: '',
      })
    })
  }
}
